export enum InputLabelHeight {
  SMALL = "small",
  DEFAULT = "default",
}
